import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";


export const fetchDashboardCallHistory = createAsyncThunk(
  "dashboard/fetchDashboardCallHistory",
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const payload = { startDate, endDate };
      console.log("payload",payload);
      
      const res = await api.post("/call/dashboard-call-history", payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const fetchCallGraph = createAsyncThunk(
  "dashboard/fetchCallGraph",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/call/inbound-outbound-call-graph");
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const dashboardDataSlice = createSlice({
  name: "dashboardData",
  initialState: {
    callHistory: [],
    callGraph: [],
    loadingHistory: false,
    loadingGraph: false,
    errorHistory: null,
    errorGraph: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardCallHistory.pending, (state) => {
        state.loadingHistory = true;
        state.errorHistory = null;
      })
      .addCase(fetchDashboardCallHistory.fulfilled, (state, action) => {
        state.loadingHistory = false;
        state.callHistory = action.payload;
      })
      .addCase(fetchDashboardCallHistory.rejected, (state, action) => {
        state.loadingHistory = false;
        state.errorHistory = action.payload;
      })
      .addCase(fetchCallGraph.pending, (state) => {
        state.loadingGraph = true;
        state.errorGraph = null;
      })
      .addCase(fetchCallGraph.fulfilled, (state, action) => {
        state.loadingGraph = false;
        state.callGraph = action.payload;
      })
      .addCase(fetchCallGraph.rejected, (state, action) => {
        state.loadingGraph = false;
        state.errorGraph = action.payload;
      });
  },
});

export default dashboardDataSlice.reducer;
